import { useState } from 'react';

export const useValidator = (initialState:any) => {

    const [valuesValid, setvaluesValid] = useState(initialState)

    const handleVerifiedValues = (objValues:any) => {

        const valuesValidTemp = { ...valuesValid }

        for (const key in valuesValidTemp) {

            if (objValues[key] !== undefined && objValues[key] !== null && objValues[key] !== '') {

                valuesValidTemp[key]['isOk'] = true

            } else {

                valuesValidTemp[key]['isOk'] = false
            }
        }

        setvaluesValid({
            ...valuesValidTemp
        })

        const objParse = JSON.stringify(valuesValidTemp)

        if (objParse.indexOf('"isOk":false') === -1)
            return true

        return false
    }

    const resetValuesValid = () => {

        const valuesValidTemp = { ...valuesValid }

        for (const key in valuesValidTemp) {

            valuesValidTemp[key]['isOk'] = true
        }

        setvaluesValid({
            ...valuesValidTemp
        })
    }

    return [valuesValid, handleVerifiedValues, resetValuesValid]

}